export enum ResponseEnumEnum {
  SUCCESS = 'success',
  ERROR = 'error'
}
